import { render, staticRenderFns } from "./appSnack.vue?vue&type=template&id=8f828f92&scoped=true&"
import script from "./appSnack.vue?vue&type=script&lang=js&"
export * from "./appSnack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f828f92",
  null
  
)

export default component.exports